import { render, staticRenderFns } from "./science.vue?vue&type=template&id=b006a63c"
import script from "./science.vue?vue&type=script&lang=js"
export * from "./science.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_l6qkhjtl3zrn5vuc55gru6hoa4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports